import { DummyModule } from './DummyModule';

export function BlockContent(props) {
  const {onremove} = props;
  const removeBlock = () => {
    onremove(props.id);
  };

  return (
      <div className="block-content">
        <button className="block-remove" onClick={removeBlock}></button>
        <div className="block-main"><DummyModule /></div>
      </div>
  );
}
